import { UPLOAD_CONFIG } from '../constants/upload';

/**
 * Returns true when the runtime appears to be a mobile browser.
 * Used to tune upload concurrency and other mobile-specific behaviour.
 */
export const isMobileBrowser = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || '';
  return /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
};

/**
 * Resolves the multipart upload concurrency for the current device class.
 * @returns {number}
 */
export const getMultipartConcurrency = () =>
  isMobileBrowser()
    ? UPLOAD_CONFIG.MOBILE_PART_CONCURRENCY
    : UPLOAD_CONFIG.DESKTOP_PART_CONCURRENCY;
